<template>
    <div class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                        Kontrollgänge
                    </h3>
                </div>
                <div class="col text-right">
                    <base-button size="sm" type="secondary" @click="changePage(page)" icon="fas fa-sync-alt"></base-button>
                    <addinspectiontour></addinspectiontour>
                </div>
            </div>
        </div>

        <div class="table-responsive" :key="tick">
            <base-table class="table align-items-center table-flush"
                        :class="type === 'dark' ? 'table-dark': ''"
                        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                        tbody-classes="list"
                        :data="tableData">
                <template slot="columns">
                    <th v-if="isAdmin">Organisation</th>
                    <!---- <th>User</th> --->
                    <TableHeadFilter title="Mitarbeiter" filter-type="dropdown" :has-filter="true" v-model="tableOptions.filter.profile" :dropdown-list="profiles" @input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Standort" filter-type="dropdown" :has-filter="true" v-model="tableOptions.filter.location" :dropdown-list="locations" @input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Status" filter-type="dropdown" :has-filter="true" v-model="tableOptions.filter.status" :dropdown-list="getStatusCollection" @input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Erledigt" filter-type="date" :has-filter="true" :has-sort="true" v-model="tableOptions.dateFilter.doneAt" :dropdown-list="profiles" @input="changePage(1)"><TableSortControl v-model="tableOptions.sort.doneAt" @input="()=> {tableOptions.sort.id = null; changePage(page); }"></TableSortControl></TableHeadFilter>
                    <th></th>
                </template>

                <template slot-scope="{row,index}">
                    <td v-if="isAdmin" v-on:dblclick="editable.push(row.id)">
                        <div v-if="computedIsLoading" class="loading"> </div><div v-else>{{$store.getters['customer/showCustomerByIRI'](row.user.customer).name}}</div>
                    </td>
                    <!---<td v-on:dblclick="editable.push(row.id)">
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.user.firstname}} {{row.user.lastname}}</div>
                    </td>---->
                    <td v-on:dblclick="editable.push(row.id)" class="px-0">
                        <div v-if="computedIsLoading" class="loading"> </div><div v-else>
                        <span v-if="!editable.includes(row.id) || isLoading">{{row.worker}}</span>
                        <select v-else v-model="row.profile"
                                class="mb-1 custom-select form-control">
                            <option v-for="profile in $store.getters['profiles/showProfilesByUser'](row.user.id)" :key="profile.id" :value="profile['@id']">{{ profile.name }}
                            </option>
                        </select></div>
                    </td>
                    <td v-on:dblclick="editable.push(row.id)">
                        <div v-if="computedIsLoading" class="loading"> </div><div v-else>{{row.location.name}}</div>
                    </td>
                    <td v-on:dblclick="editable.push(row.id)" class="px-0">
                        <div v-if="computedIsLoading" class="loading"> </div><div v-else>

                        <span v-if="!editable.includes(row.id) || isLoading">{{$store.getters['status/getStatusByIRI'](row.status).text}}</span>
                        <select v-else v-model="row.status"
                                class="mb-1 custom-select form-control">
                            <option v-for="status in getStatusCollection" :key="status.id" :value="status['@id']">{{ status.text }}
                            </option>
                        </select>

                        </div>
                    </td>
                    <td v-on:dblclick="editable.push(row.id)" class="px-0">
                        <div v-if="computedIsLoading" class="loading"> </div><div v-else>
                        <span v-if="!editable.includes(row.id) || isLoading">{{row.doneAt | formatDate }}</span>
                        <base-input v-else
                                required
                                class="col-form-label mb-0"
                                placeholder="Datum&Uhrzeit der Durchführung">

                            <flat-pickr slot-scope="{focus, blur}"
                                        @on-open="focus"
                                        @on-close="blur"
                                        ref="pickr"
                                        :config="config"
                                        class="form-control mb-1 datepicker"
                                        v-model="row.doneAt">
                            </flat-pickr></base-input>
                    </div>
                    </td>
                    <td class="text-right">
                        <div v-if="computedIsLoading" class="loading-button"> </div><div v-else><template>
                        <div v-if="!row.delete">
                            <base-button v-if="!editable.includes(row.id)" v-on:click="editable.push(row.id)" icon="fas fa-pencil-alt" type="secondary" icon-only
                                         title="Quickedit"></base-button>
                            <div v-else>
                                <base-button v-on:click="editable.splice(editable.indexOf(row.id),1)" v-if="!isLoading" icon="fa fa-ban" type="secondary" icon-only
                                             title="abbrechen"></base-button>
                                <base-button :key="tick+'ncb1'" v-on:click="editIT(row)" :disabled="currentlyLoading.includes(row.id)" :icon="(currentlyLoading.includes(row.id)) ? 'fas fa-circle-notch fa-spin' : 'fas fa-save'" type="primary" icon-only
                                             title="speichern"></base-button></div>
                        </div>
                        <base-button v-if="!row.delete && !$store.getters['authentication/isService']" type="secondary" icon="far fa-trash-alt" icon-only v-on:click="deleteConfirmation(index)"></base-button>
                        <div v-if="row.delete" style="margin-top: 1rem;"><span  class="text-danger">Sicher? <i class="fas fa-trash-alt"></i></span><br>
                            <base-button :key="tick+'ncb2'" v-if="row.delete" size="sm" :disabled="currentlyLoading.includes(row.id)" :icon="(currentlyLoading.includes(row.id)) ? 'fas fa-circle-notch fa-spin' : 'fas fa-check'" type="danger" v-on:click="deleteIT(row)">Ja</base-button>
                            <base-button v-if="row.delete" size="sm" type="info" icon="fas fa-times" v-on:click="deleteConfirmation(index)">Nein</base-button>
                        </div>
                    </template>
                    </div>
                    </td>
                </template>
            </base-table>
        </div>

        <div class="card-footer d-flex justify-content-end"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <base-pagination :total="totalitems" v-on:input="changePage" :value="page"></base-pagination>
        </div>

    </div>
</template>

<script>
    import moment from 'moment-timezone'
    import Addinspectiontour from "@/views/InspectionTours/addinspectiontour";
    import FlatPickr from "vue-flatpickr-component/src/component";
    import "flatpickr/dist/flatpickr.css";
    import { German } from "flatpickr/dist/l10n/de.js";
    import TableHeadFilter from "@/components/TableHeadFilter";
    import TableSortControl from "@/components/TableSortControl";
    export default {
        name: "list",
        components:{TableSortControl, TableHeadFilter, FlatPickr, Addinspectiontour},
        props: {
            type: {
                type: String
            },
            title: String
        },
        data() {
            return {
                tableOptions: {
                    filter: {
                        location: null,
                        profile: null,
                        status: null
                    },
                    dateFilter: {
                        doneAt: null
                    },
                    sort:{
                        id: 'DESC',
                        doneAt: null
                    }},
                editable: [],
                currentlyLoading: [],
                tableData: [
                    {
                        id: 0,
                        profile: {
                            name: ''
                        },
                        worker: '',
                        user: {
                            firstname: '',
                            lastname: '',
                            customer: {
                                name: ''
                            }
                        },
                        location: {
                            name: ''
                        },
                        status: {
                            name: ''
                        },
                        doneAt: new Date(),
                        stat: '',
                        comment: ''
                    }
                ],
                config: {
                    dateFormat: 'YYYY-MM-DDTHH:mm:ssZ',
                    altFormat: 'DD.MM.YYYY HH:mm',
                    enableTime: true,
                    time_24hr: true,
                    altInput: true,
                    allowInput: true,
                    locale: German,
                    parseDate(dateString, format) {
                        let timezonedDate = new moment.tz(dateString, format, 'Europe/Berlin');

                        return new Date(
                            timezonedDate.year(),
                            timezonedDate.month(),
                            timezonedDate.date(),
                            timezonedDate.hour(),
                            timezonedDate.minute(),
                            timezonedDate.second()
                        );
                    },
                    formatDate(date, format) {
                        let time;
                        if (format ==='YYYY-MM-DDTHH:mm:ssZ'){
                            time = moment.tz([
                                date.getFullYear(),
                                date.getMonth(),
                                date.getDate(),
                                date.getHours(),
                                date.getMinutes(),
                                date.getSeconds()
                            ], 'Europe/Berlin').utc().format();
                        } else {
                            time = moment.tz([
                                date.getFullYear(),
                                date.getMonth(),
                                date.getDate(),
                                date.getHours(),
                                date.getMinutes(),
                                date.getSeconds()
                            ], 'Europe/Berlin').locale('en-GB').format(format);
                        }

                        return time;
                    }
                },
                totalitems: 0,
                page: 1,
                isLoading: false,
                tick: 1
            }
        },
        created() {
            this.changePage(this.page);
            if (!this.$store.getters['profiles/isReady']) this.$store.dispatch('profiles/getProfiles');
            if (!this.$store.getters['customer/isReady']) {
                this.$store.dispatch('customer/getCustomerCollection');
            }
        },
        computed: {
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            },
            getStatusCollection() {
                return this.$store.getters['status/showStatusCollection'];
            },
            computedIsLoading() {
                return this.$store.getters['status/isLoading'] || this.$store.getters['profiles/isLoading'] || this.$store.getters['customer/isLoading'] || this.isLoading
            },
            profiles() {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                return (!this.$store.getters['profiles/isReady']) ? [] : this.$store.getters['profiles/showProfiles'].sort((a, b) =>{
                    return a.name.localeCompare(b.name);
                });
            },
            locations() {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                return (!this.$store.getters['location/isReady']) ? [] : this.$store.getters['location/showLocationCollection'].sort((a, b) =>{
                    return a.name.localeCompare(b.name);
                });
            }
        },
        methods: {
            changePage(page) {
                this.isLoading = true;
                this.tick++;
                this.getTableData(page).then(
                    response => {
                        this.tableData = response.member;
                        this.tableData.forEach(item => {
                            item.worker = item.profile.name;
                            item.profile = item.profile['@id'];
                            item.status = item.status['@id'];
                        });
                        this.totalitems = response.totalItems;
                        this.page = page;
                        this.isLoading = false;
                        this.tick++;
                    }
                )
            },
            getTableData(page){
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    fetch(process.env.VUE_APP_API_SERVER + `/api/inspection_tours?` + this.getUrlExtension(this.tableOptions.filter,this.tableOptions.sort,this.tableOptions.dateFilter) + `&page=` + page, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            resolve({
                                totalItems: response['hydra:totalItems'],
                                member: response['hydra:member']
                            });
                        }, error => {reject(error); });
                });
            },
            editIT(data) {
                return new Promise(() => {
                    this.currentlyLoading.push(data.id);
                    this.tick++;
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/merge-patch+json';
                    let senddata = JSON.parse(JSON.stringify(data));
                    delete senddata.user;
                    delete senddata.location;
                    const requestOptions = {
                        method: 'PATCH',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/inspection_tours/`+data.id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.$store.dispatch('alert/success', 'Kontrollgang (ID: '+response.id+') wurde editiert.');
                                this.changePage(this.page);
                                this.currentlyLoading.splice(this.currentlyLoading.indexOf(data.id),1);
                                this.editable.splice(this.editable.indexOf(data.id),1);
                                this.tick++;
                            },
                            error => {
                                this.currentlyLoading.splice(this.currentlyLoading.indexOf(data.id),1);
                                this.tick++;
                                this.$store.dispatch('alert/error', error);
                            });

                    this.tick++;
                });
            },
            deleteIT(data) {
                return new Promise((resolve, reject) => {
                    this.currentlyLoading.push(data.id);
                    this.tick++;
                    //this.deleteConfirmation(this.tableData.indexOf(data));
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'DELETE',
                        headers: header,
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/inspection_tours/`+data.id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                                this.changePage(this.page);
                                this.currentlyLoading.splice(this.currentlyLoading.indexOf(data.id),1);
                                this.tick++;
                            },
                            error => {
                                reject(error);
                                this.currentlyLoading.splice(this.currentlyLoading.indexOf(data.id),1);
                                this.tick++;
                            });
                });
            },
            deleteConfirmation(index) {
                if(typeof this.tableData[index].delete === "undefined") {
                    this.tableData[index].delete = false;
                }
                this.tableData[index].delete = !this.tableData[index].delete;
                this.tick++;
            }
        }
    }
</script>

<style scoped>

</style>